export default {
  items: [
    {
      name: 'Gerenciamento',
      icon: 'icon-speedometer',
      children: [
        {
          name: 'Usuários',
          url: '/usuarios',
          icon: 'fa fa-users'
        },
        {
          name: 'Captchas',
          url: '/captchas',
          icon: 'fa fa-sign-language'
        },
        {
          name: 'Perfil',
          icon: 'fa fa-user-circle',
          children: [
            {
              name: 'Gestão de acesso',
              url: '/perfis',
              icon: 'fa fa-key'
            }
          ]
        }
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/_nav.js